import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrash, FaToggleOn, FaToggleOff } from 'react-icons/fa';

const CreateNewEvent = () => {
    const [eventName, setEventName] = useState('');
    const [file, setFile] = useState(null);
    const [events, setEvents] = useState([]);
    const [error, setError] = useState('');
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();


    const [quotaInfo, setQuotaInfo] = useState(null);

    const fetchQuotaStatus = async (uid) => {
        try {
            const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/subscription/current-status/${uid}`);
            if (res.data?.success) {
                setQuotaInfo(res.data);
            }
        } catch (err) {
            console.error('Failed to load quota:', err);
        }
    };

    useEffect(() => {
        if (user?.id) {
            fetchQuotaStatus(user.id);
        }
    }, [user]);



    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
        }
    }, []);

    useEffect(() => {
        if (user?.id) {
            fetchEvents();
        }
    }, [user]);

    const fetchEvents = async () => {
        if (!user?.id) {
            setError('User ID is missing');
            return;
        }
        try {
            setLoading(true);
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            setError('Error fetching events');
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!eventName) {
//             setError('Please provide an event name.');
//             return;
//         }
//         const formData = new FormData();
//         formData.append('name', eventName);
//         if (file) formData.append('file', file);
//         if (user) formData.append('userId', user.id);
//        formData.append('flag', selectedEvent ? String(selectedEvent.flag) : '0');

//   try {
//             setLoading(true);
//             setError('');
//             if (selectedEvent) {
//                 await axios.put(`https://rvapi.emedha.in/pages/api/api/events/${selectedEvent.id}`, formData);
//             } else {
//                 await axios.post('https://rvapi.emedha.in/pages/api/api/events', formData);
//             }
//             fetchEvents();
//             if (user?.id) fetchQuotaStatus(user.id); // refresh quota counter
//             setEventName('');
//             setFile(null);
//             setSelectedEvent(null);
//         } catch (error) {
//             // Show exact quota/subscription error message from server
//             setError(error.response?.data?.error || 'Error saving event');
//         } finally {
//             setLoading(false);
//         }
//     };


const handleSubmit = async (e) => {
        e.preventDefault();
        if (!eventName) {
            setError('Please provide an event name.');
            return;
        }
        const formData = new FormData();
        formData.append('name', eventName);
        if (file) formData.append('file', file);
        if (user) formData.append('userId', user.id);

        // Keep existing flag if editing; set to '0' if creating new event
        const flagValue = selectedEvent ? String(selectedEvent.flag) : '0';
        formData.append('flag', flagValue);

        try {
            setLoading(true);
            setError('');
            if (selectedEvent) {
                await axios.put(`https://rvapi.emedha.in/pages/api/api/events/${selectedEvent.id}`, formData);
            } else {
                await axios.post('https://rvapi.emedha.in/pages/api/api/events', formData);
            }
            fetchEvents();
            if (user?.id) fetchQuotaStatus(user.id);
            setEventName('');
            setFile(null);
            setSelectedEvent(null);
        } catch (error) {
            setError(error.response?.data?.error || 'Error saving event');
        } finally {
            setLoading(false);
        }
    };

    // const toggleFlag = async (eventId, currentFlag) => {
    //     if (!user?.id) return;
    //     // If it's already active (1), keep it 1 (one event must always remain active)
    //     // If clicking an inactive one (0), set it to 1 (backend deactivates all others)
    //     const targetFlag = currentFlag === 1 ? 0 : 1;

    //     try {
    //         await axios.put(`https://rvapi.emedha.in/pages/api/api/events/${eventId}/flag`, {
    //             flag: targetFlag,
    //             userId: user.id
    //         });
    //         fetchEvents();
    //     } catch (error) {
    //         setError('Error toggling flag');
    //     }
    // };


    const handleEdit = (event) => {
        setSelectedEvent(event);
        setEventName(event.name);
    };

    const handleDelete = async (eventId) => {
        try {
            await axios.delete(`https://rvapi.emedha.in/pages/api/api/events/${eventId}`);
            fetchEvents();
        } catch (error) {
            setError('Error deleting event');
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    const toggleFlag = async (eventId, newFlag) => {
        if (!user?.id) return;
        try {
            await axios.put(`https://rvapi.emedha.in/pages/api/api/events/${eventId}/flag`, {
                flag: newFlag,
                userId: user.id
            });
            fetchEvents();
        } catch (error) {
            setError('Error toggling flag');
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <div style={{ flex: 1, overflow: 'auto' }}>
                <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                    <img src={events.find((event) => event.flag === 1)?.file || ''} alt="Logo" style={{ width: '100px' }} />
                    <div style={{ flexGrow: 1, textAlign: 'center' }}>
                        <h2 style={{ color: '#333', fontSize: '24px', fontWeight: '600' }}>
                            {events.length > 0 ? events[0].name : 'No event available'}
                        </h2>
                    </div>
                </div>

                <div className="mt-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: 'solid 2px black', borderRadius: '20px', padding: '10px' }}>
                    <IoArrowBackCircle onClick={handleBack} size={45} style={{ cursor: 'pointer', borderRadius: '20px' }} />
                    <h2 className="text-center" style={{ flexGrow: 1, textAlign: 'center', margin: 0 }}>CREATE or UPDATE EVENT</h2>
                </div>

                

                <div className="container mt-4">
       
            {/* PLAN QUOTA STRIP */}
{quotaInfo && (
    <div 
        className="p-3 mb-3 rounded-3 d-flex justify-content-between align-items-center"
        style={{
            backgroundColor: quotaInfo.quizzesRemaining === 0 ? '#fee2e2' : '#f0fdf4',
            border: `1px solid ${quotaInfo.quizzesRemaining === 0 ? '#fca5a5' : '#86efac'}`
        }}
    >
        <div>
            <strong style={{ color: quotaInfo.quizzesRemaining === 0 ? '#991b1b' : '#166534' }}>
                Active Plan: {quotaInfo.planTier ? quotaInfo.planTier.toUpperCase() : 'TRIAL'}
            </strong>
            <span className="ms-2" style={{ fontSize: '13px', color: '#374151' }}>
                (Used <strong>{quotaInfo.usedQuizzes}</strong> of {quotaInfo.allowedQuizzes} Event Quizzes &bull; 
                <strong className="ms-1" style={{ color: quotaInfo.quizzesRemaining === 0 ? '#b91c1c' : '#15803d' }}>
                    {quotaInfo.quizzesRemaining} remaining
                </strong>)
            </span>
            <small className="d-block text-muted" style={{ fontSize: '11px', marginTop: '2px' }}>
                Total Events configured: {quotaInfo.totalEventsCreated || 0} (Quota is only deducted once questions are added)
            </small>
        </div>

        {quotaInfo.quizzesRemaining === 0 && (
            <button 
                type="button" 
                onClick={() => navigate('/Dashboard/45g676tr/Dashboard')} 
                className="btn btn-sm btn-danger fw-bold"
                style={{ borderRadius: '8px' }}
            >
                Upgrade Plan in Dashboard
            </button>
        )}
    </div>
)}
                    <form onSubmit={handleSubmit} className="mb-4 mt-5">
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label>Event Name:</label>
                                    <input type="text" value={eventName} onChange={(e) => setEventName(e.target.value)} placeholder="Enter event name" className="form-control" />
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label>Upload Company logo File:</label>
                                    <input type="file" onChange={handleFileChange} className="form-control" />
                                </div>
                            </div>
                            <div className="col-4 mt-4">
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {selectedEvent ? 'Update Event' : 'Create Event'}
                                </button>
                            </div>
                        </div>
                    </form>

                    <h2>Event List</h2>
                    {loading && <p>Loading events...</p>}
                    {!loading && events.length === 0 && <p>No events available.</p>}

                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Event Name</th>
                                    <th scope="col">File</th>
                                    <th scope="col">Activate</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events.map((event) => (
                                    <tr key={event.id}>
                                        <td>{event.name}</td>
                                        <td><img src={event.file} width="50" alt="Event File" /></td>
                                        <td>
                                            <button
                                                onClick={() => toggleFlag(event.id, event.flag === 1 ? 0 : 1)}
                                                className={`btn btn-sm ${event.flag === 1 ? 'btn-success' : 'btn-secondary'}`}
                                                title={event.flag === 1 ? 'Click to Deactivate' : 'Click to Activate'}
                                            >
                                                {event.flag === 1 ? <FaToggleOn /> : <FaToggleOff />}
                                            </button>
                                        </td>
                                        <td>
                                            <button onClick={() => handleEdit(event)} className="btn btn-warning btn-sm me-2" title="Edit"><FaEdit /></button>
                                            {/* <button onClick={() => handleDelete(event.id)} className="btn btn-danger btn-sm" title="Delete"><FaTrash /></button> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <footer style={{ backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', padding: '20px 0' }}>
                <p>© 2025 Quizifyai. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default CreateNewEvent;
